import {IntermediatePart} from "../../parts/intermediatePart";

export default class WallA extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'wall_a';
    this.activeFeatureBeforeAllWalls = null;
    this.partName = 'Wall A';
    this.translateId = "visualizer.bathroom.walls.wall_a";
    this.allWallsApplied = true;
    this.isStoneFeature = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new WallA());
  }

  setZIndex(zIndexes) {
    if(zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndexes.Wall_A;
      if (this.placeholderFeature) {
        this.placeholderFeature.layer.zIndex = zIndexes.Wall_A;
      }
    }
  }

  // handleClick(clickFrom) {
  //   if (clickFrom === 'simpleWall' || clickFrom === 'showerWall' || clickFrom === 'vanityWall') {
  //     const parent = this.getParent();
  //     if (clickFrom === 'simpleWall') {
  //       parent.allWallsApplied = true;
  //     }
  //     parent.activeFeatureBeforeAllWalls = parent.activeFeature;
  //     if (!parent.placeholderChanged) {
  //       parent.rememberToRecoverPlaceholder = true;
  //     }
  //   }
  //   super.handleClick();
  // }

  // unCheckAllWalls(clickFrom, navPart) {
  //   if (clickFrom === 'simpleWall') {
  //     this.allWallsApplied = false;
  //   }
  //   if (!(navPart instanceof WallA)) {
  //     if (this.activeFeatureBeforeAllWalls) {
  //       this.activeFeatureBeforeAllWalls.handleClick();
  //       this.activeFeatureBeforeAllWalls = null;
  //     }
  //     if (this.rememberToRecoverPlaceholder) {
  //       this.placeholderChanged = false;
  //       this.rememberToRecoverPlaceholder = false;
  //     }
  //   }
  // }

}
